export const DESIGN_ONLY_SERVICE = 'design_only'
export const DESIGN_ONLY_KICKOFF_URL = 'https://calendly.com/jason-blissbunkbeds/kickoff-meeting'
export const DESIGN_ONLY_DESCRIPTION = 'Custom room design, complete parts list and complete cut list. Fabrication and installation are not included.'
